/*
 * Currently, we are using the subGenresConstant for routing, considering it's an MVP.
 * TODO:this data should be stored in the store and retrieved from the API.
 */
export const subGenresConstant = [
	{
		name: 'Rom Coms',
		fullPath: '/us/lists/rom-coms',
		shortName: 'coro',
		slug: 'rom-coms',
	},
	{
		name: 'Adventure',
		fullPath: '/us/lists/adventure',
		shortName: 'adva',
		slug: 'adventure',
	},
	{
		name: 'Anime',
		fullPath: '/us/lists/anime',
		shortName: 'jpan',
		slug: 'anime',
	},
];
